import { useState } from 'react';
import { getTimespanConfig } from '../../config';
import { ChartSettings, Resolution, Timespan } from '../../model';

export type ChartSettingsInteractionModel = {
  chartSettings: ChartSettings;
  setTimespan: (timespan: Timespan) => void;
  setResolution: (resolution: Resolution) => void;
};

export const useChartSettings = (initialValues?: Partial<ChartSettings>): ChartSettingsInteractionModel => {
  const [timespan, setTimespan] = useState<Timespan>(initialValues?.timespan || Timespan.FiveMinutes);
  const [resolution, setResolution] = useState<Resolution>(initialValues?.resolution || Resolution.FiveMinutes);

  const updateResolution = (resolution: Resolution): void => {
    const timespanConfig = getTimespanConfig(timespan);
    if (timespanConfig.allowedResolutions.includes(resolution)) {
      setResolution(resolution);
    } else {
      throw new Error(`Resolution "${resolution}" is not allowed to be set with timespan "${timespan}".`);
    }
  };

  const updateTimespan = (timespan: Timespan): void => {
    const defaultResolution = getTimespanConfig(timespan).defaultResolution;
    setTimespan(timespan);
    setResolution(defaultResolution);
  }

  return {
    chartSettings: {
      timespan,
      resolution,
    },
    setTimespan: updateTimespan,
    setResolution: updateResolution,
  };
};
